import PageHero from '@/components/sections/shared/PageHero'
import Anchor from '@/components/ui/Anchor'
import { useData } from '@/hooks/useLocale'

/** The 404 hero with a way back home; the spacer keeps the footer at the bottom. */
export default function NotFoundSection() {
  const { NOT_FOUND } = useData()

  return (
    <>
      <PageHero
        eyebrow={NOT_FOUND.eyebrow}
        title={NOT_FOUND.title}
        text={NOT_FOUND.text}
      >
        <Anchor
          href={NOT_FOUND.cta.href}
          className="mt-2 flex h-12 items-center self-start rounded-full bg-white px-[22px] text-sm font-semibold text-ink hover:bg-brand-tint"
        >
          {NOT_FOUND.cta.label}
        </Anchor>
      </PageHero>
      <div className="flex-1" />
    </>
  )
}
